import Boundaries from "../../../views/Boundaries";
import MenuNames from "../../../constants/Menu/MenuNames.json";

const BoundariesRoutes = [
  {
    menuName: MenuNames.GEO_BOUNDARIES_DISPLAY,
    path: "/boundaries",
    component: Boundaries,
    exact: true,
  },
];

export default BoundariesRoutes;
